import removeOrphans from '@/helpers/removeOrphans'
import type { App } from 'vue'

const getTextNodes = (el: HTMLElement): Node[] => {
  let n
  const a = []
  const walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null)

  while ((n = walk.nextNode())) a.push(n)
  return a
}

const setNodeValue = (node: Node, value: string | null): void => {
  const textNode = node
  textNode.nodeValue = value
}

const updateNodes = (nodes: Node[]) => {
  if (nodes && nodes.length > 0) {
    Object.entries(nodes).forEach(([, textNode]) => {
      const { nodeValue } = textNode
      if (typeof nodeValue === 'string') {
        setNodeValue(textNode, removeOrphans(nodeValue))
      }
    })
  }
}

const initOrphansDirective = (app: App): void => {
  app.directive('orphans', (element: HTMLElement) => {
    const nodes = getTextNodes(element)
    updateNodes(nodes)
  })
}

export default initOrphansDirective
